import React from 'react';
export function Ingredients() {
  return <section className="mb-24" data-id="element-179">
      <h2 className="text-[28px] sm:text-[32px] md:text-[36px] font-semibold text-[#1B2951] mb-8 leading-tight font-['Playfair_Display']" data-id="element-180">
        Inside Every Scoop
      </h2>
      <div className="mb-10" data-id="element-181">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5AaHwaPn1XhTpwjKcZPhwD/u8357357769_Beauty_science_laboratory_setup_4_different_glass_78396c4a-17e2-4509-bc01-54f6292c7fd3_3.png" alt="Scientific laboratory setup showing pure ingredients in glass beakers and dishes - marine collagen, CERAMOSIDES™, and other active ingredients" className="w-full rounded-lg shadow-md mb-3" data-id="element-182" />
        <p className="text-[14px] text-[#7F8C8D] text-center italic font-['Inter']" data-id="element-183">
          Our premium ingredients in their purest form, scientifically measured
          for the perfect balance in every scoop
        </p>
      </div>
      <div className="grid md:grid-cols-2 gap-6" data-id="element-184">
        <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-all duration-300 hover:scale-[1.02] border border-[#7F8C8D]/10" data-id="element-185">
          <h3 className="text-xl font-semibold text-[#1B2951] mb-4 font-['Poppins']" data-id="element-186">
            Marine Collagen (8g)
          </h3>
          <p className="text-[#2C3E50] font-['Inter']" data-id="element-187">
            60% more than standard supplements
          </p>
        </div>
        <div className="bg-gradient-to-br from-[#FFB88C] to-[#FFE5D9] rounded-lg shadow-md p-6 hover:shadow-lg transition-all duration-300 hover:scale-[1.02] border border-[#FFB88C]/50" data-id="element-188">
          <h3 className="text-xl font-semibold text-[#1B2951] mb-4 font-['Poppins']" data-id="element-189">
            CERAMOSIDES™
          </h3>
          <p className="text-[#1B2951] font-['Inter']" data-id="element-190">
            Patented French innovation
          </p>
        </div>
        <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-all duration-300 hover:scale-[1.02] border border-[#7F8C8D]/10" data-id="element-191">
          <h3 className="text-xl font-semibold text-[#1B2951] mb-4 font-['Poppins']" data-id="element-192">
            Vitamin C
          </h3>
          <p className="text-[#2C3E50] font-['Inter']" data-id="element-193">
            Enhances collagen synthesis
          </p>
        </div>
        <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-all duration-300 hover:scale-[1.02] border border-[#7F8C8D]/10" data-id="element-194">
          <h3 className="text-xl font-semibold text-[#1B2951] mb-4 font-['Poppins']" data-id="element-195">
            Biotin + Hyaluronic Acid
          </h3>
          <p className="text-[#2C3E50] font-['Inter']" data-id="element-196">
            Complete beauty nutrition
          </p>
        </div>
      </div>
    </section>;
}